import React from 'react'

import { bool, string } from 'prop-types'

const IMAGE_WIDTH = 1080
const IMAGE_HEIGHT = 617

function Card({ href, heading, imageSrc = '', eager = false }) {
  return (
    <a className="ai-generator-hub__card" href={href}>
      {imageSrc && (
        <img
          className="ai-generator-hub__card-image"
          src={imageSrc}
          alt=""
          width={IMAGE_WIDTH}
          height={IMAGE_HEIGHT}
          loading={eager ? 'eager' : 'lazy'}
          decoding="async"
        />
      )}
      <h2 className="ai-generator-hub__card-title cgt-heading-300">{heading}</h2>
    </a>
  )
}

Card.propTypes = {
  href: string.isRequired,
  heading: string.isRequired,
  imageSrc: string,
  eager: bool,
}

export default Card
